import React, { useEffect, useState } from "react";
import { db } from "../firebase-config";
import { collection, getDocs, query, where } from "firebase/firestore"
import img1 from "../Components/images/image_17d77d38 (1).png"
import img2 from "../Components/images/image_aa93eb8d.png"
import img3 from "../Components/images/image_d52cddda.png"
import img4 from "../Components/images/image_b784bd5e (1).png"
import CircularProgress from "@mui/material/CircularProgress";
import AOS from "aos";
import "aos/dist/aos.css";

const Aboutuspage = () => {
  const [Aboutustransfersservices, AboutustransfersServices] = useState([]);
  const headerData = Aboutustransfersservices[0];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "Aboutus")
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        AboutustransfersServices(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // ✅ important
      }
    };
    fetchServices();
  }, []);
   useEffect(() => {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
      });
    }, []);

  // 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }
  return (
    <div className="business-page">

      <div
        className="mainhero-container"
        style={{
          backgroundImage: `url(${headerData?.headerimage ||
            "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1920&q=80"
            })`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="mainhero-content">

          <h1>
            <span style={{ color: "#45B2F7" }}>
              {headerData?.headerTitle?.split(" ")[0] || "MAS "}
            </span>{" "}
            {headerData?.headerTitle?.split(" ").slice(1).join(" ") ||
              "Mobility Services"}
          </h1>

          <p>
            {headerData?.headerDescription ||
              "At MAS Mobility Service, we provide reliable and seamless corporate transportation solutions tailored for businesses, travel agencies, hotels, and companies. Our commitment is to deliver safe, comfortable, and efficient travel experiences with professional service and premium mobility support..."}
          </p>

          {/* BUTTON */}
          <button
            style={{
              marginTop: "20px",
              padding: "14px 30px",
              backgroundColor: "blue",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.3s ease",
            }}
          >
            Become a Partner
          </button>

        </div>
      </div>

      {/* ================= FEATURE CARDS ================= */}
      <section className="business-features">
        <div className="feature-container">

          {/* CARD 1 */}
          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1519003722824-194d4455a60c?auto=format&fit=crop&w=800&q=80"
              alt="Taxi Service"
            />
            <h3>About MAS Mobility Service</h3>
            <p>
              MAS Mobility Service is a trusted transportation service provider committed to delivering safe, reliable, and efficient travel solutions for individuals and businesses. With a strong focus on customer satisfaction, we provide seamless cab services tailored to meet modern travel needs.
              Whether it’s daily commuting, airport transfers, or corporate travel, MAS Mobility Service ensures a smooth and comfortable journey with professional drivers and well-maintained vehicles.
            </p>
          </div>

          {/* CARD 2 */}
          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80"
              alt="Team Planning"
            />
            <h3>Our Mission</h3>
            <p>
              Our mission is to simplify transportation by offering dependable, affordable, and high-quality cab services. We aim to build long-term relationships with our customers by consistently delivering excellence, safety, and convenience in every ride.
            </p>
          </div>

          {/* CARD 3 */}
          <div className="feature-card">
            <img
              src={img1}
              alt="City Vision"
            />
            <h3>Our Vision</h3>
            <p>
              To become a leading transportation partner for individuals and businesses by setting new standards in service quality, innovation, reliability, and customer satisfaction. We envision a future where MAS Mobility Service is recognized for delivering exceptional travel experiences through advanced technology, professional service, and a strong commitment to safety and comfort. Our goal is to expand our reach while continuously improving the quality of transportation solutions for every customer.
            </p>
          </div>

          <div className="feature-card">
            <img
              src={img4}
              alt="Professional Driver"
            />
            <h3>Our Commitment</h3>
            <p>
              At MAS Mobility Service, we are committed to delivering a stress-free and premium travel experience. We prioritize safety, punctuality, and customer satisfaction in every journey, ensuring that you can rely on us anytime, anywhere.
            </p>
          </div>

          <div className="feature-card">
            <img
              src={img2}
              alt="Professional Driver"
            />
            <h3>Customer First Approach</h3>
            <p>
              At MAS Mobility Service, our customers are at the heart of everything we do.
              We focus on delivering reliable, safe, and comfortable rides by
              understanding your needs and exceeding expectations with every journey.
            </p>
          </div>

          <div className="feature-card">
            <img
              src={img3}
              alt="Professional Driver"
            />
            <h3>Service Excellence</h3>
            <p>
              We are dedicated to maintaining the highest standards of service
              through well-trained drivers, clean vehicles, and timely pickups.
              Every ride with MAS Mobility Service reflects our commitment to quality
              and professionalism.
            </p>
          </div>

        </div>
      </section>



      {/* EMPLOYEE SECTION */}
      <div>
        {loading ? (
          <div className="skeleton-card">loading ....</div>
        ) : Aboutustransfersservices?.length === 0 ? (
          <h2 style={{ textAlign: "center" }}>No data found</h2>
        ) : (
          Aboutustransfersservices?.map((service, index) => (
            <div
              key={service.id}
              className={`service-section ${index % 2 !== 0 ? "reverse" : ""
                }`}
            >
              {/* IMAGE */}
              <div
                className="service-image"
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <img src={service?.image || img2} alt={service.description} />
              </div>

              {/* CONTENT */}
              <div className="service-content">
                <h2>{service.description}</h2>

                <ul className="service-list-business">
                  {service?.content
                    ?.split(".")
                    .filter((item) => item.trim() !== "")
                    .map((item, index) => (
                      <li key={index}>

                        {item.trim()}
                      </li>
                    ))}
                </ul>
              </div>

            </div>
          ))
        )}
      </div>


    </div>
  );
};

export default Aboutuspage;